import REQUESTS from "../../../api/requests";
import { useEffect, useState, useContext } from "react";
import { Table, Button, Input, Modal, DatePicker, Switch, Popover, Image } from "antd";
import { emptyContext } from "../../../context_empty/context_empty";
import TableButtons from "../../../components/TableButtons";
import classes from "../style/newsTable.module.scss";
import { useSelector } from "react-redux";
import { selectTranslation } from "../../../features/Translation/TranslationSlice";
import NewsTableDrawer from "./NewsTableDrawer";
import getMyDate from "../../../components/getMyDate";
import TEXT from "../../../config/text";
import {
    DeleteOutlined,
    EditOutlined,
    PlusOutlined,
    SearchOutlined,
    ShoppingOutlined,
    CalendarOutlined,
} from "@ant-design/icons";
import InitialParams from "../../../components/InitialParams";
import { createSearchParams, useNavigate, useSearchParams } from "react-router-dom";
const { RangePicker } = DatePicker;
const { confirm } = Modal;

function NewsTable() {
    const [empty, setEmpty] = useContext(emptyContext);
    const [searchParams, setsearchParams] = useSearchParams();
    const [total, setTotal] = useState();
    const [limit, setLimit] = useState(10);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [visible, setVisible] = useState(false);
    const [editNews, setEditNews] = useState(null);
    const [date, setDate] = useState("");
    const [userNewsList, setUserNewsList] = useState([]);
    const [sort, setSort] = useState(["id", "DESC"]);
    const [search, setSearch] = useState({
        comment: "",
    });

    const translation = useSelector(selectTranslation);
    const navigate = useNavigate();

    InitialParams(setLimit, setCurrentPage, setSearch, setSort);

    const goToPosts = (params) =>
        navigate({
            search: `?${createSearchParams(params)}`,
        });

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
            return (
                <Input
                    allowClear
                    autoFocus
                    placeholder="Type text here"
                    value={search[0]}
                    onChange={(e) => {
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                        confirm({ closeDropdown: false });
                    }}
                />
            );
        },
        filterIcon: () => {
            return (
                <>
                    <SearchOutlined />
                </>
            );
        },
    });

    const deleteTable = (id) => {
        const callback = (data) => {
            getNews();
        };

        const errorCallback = (data) => {};

        REQUESTS.NEWS.DELETE(id, callback, errorCallback);
    };

    const handleMenuClick = (e, item) => {
        switch (e.key) {
            case "delete":
                showPropsConfirm(item.id);
                break;

            case "edit":
                setEditNews(item);
                setVisible(true);
                break;

            default:
                break;
        }
    };

    const showPropsConfirm = (id) => {
        confirm({
            content: "Are you sure you want to delete?",
            okText: "DELETE",
            okType: "default",
            okButtonProps: {
                disabled: false,
                style: {
                    backgroundColor: "#bf4342",
                    color: "#fff",
                },
                loading: loading,
            },

            cancelText: "CANCEL",
            onOk() {
                deleteTable(id);
            },

            onCancel() {},
        });
    };

    const columns = [
        {
            title: "#",
            width: "60px",
            dataIndex: "id",
            align: "center",
            render: (text, record, index) => {
                if (currentPage === 1) {
                    return index + 1;
                } else {
                    return limit * (currentPage - 1) + index + 1;
                }
            },
        },
        {
            title: `${translation["Title"] || TEXT["Title"]}`,
            width: "100px",
            dataIndex: "title",
            key: "title",
            align: "center",
            ...getColumnSearchProps(),
        },
        {
            title: `${translation["Description"] || TEXT["Description"]}`,
            dataIndex: "description",
            width: "200px",
            align: "center",
            render: (record, text, index) => {
                if (record) {
                    const content = record;
                    return (
                        <Popover content={ <div dangerouslySetInnerHTML={{ __html: content }} />}>
                            <div className={classes["ref-link"]} dangerouslySetInnerHTML={{ __html: record }} />
                        </Popover>
                    );
                }
            },
            ...getColumnSearchProps(),
        }, 
        {
            title: `${translation["Images"] || TEXT["Images"]}`,
            width: "150px",
            dataIndex: "image",
            align: "center",
            render: (record, text, index) => {
                return <Image width={100} src={`${record}`} />;
            },
        },
        {
            title: ` ${translation["Date"] || TEXT["Date"]}`,
            align: "center",
            width: "150px",
            dataIndex: "createdAt",
            sorter: true,
            render: (record) => {
                return getMyDate(record);
            },
            filterDropdown: ({}) => (
                <div
                    style={{
                        padding: 8,
                    }}
                >
                    <RangePicker
                        size="small"
                        onChange={(e, dateString) => setDate(dateString)}
                        renderExtraFooter={() => "extra footer"}
                    />
                </div>
            ),
            filterIcon: (filtered) => (
                <CalendarOutlined
                    style={{
                        color: JSON.parse(searchParams.get("between"))?.createdAt
                            ? "#1890ff"
                            : undefined,
                    }}
                />
            ),
        },
        {
            title: "",
            width: "60px",
            dataIndex: "action",
            align: "center",
            render: (text, record, index) => (
                <TableButtons
                    handleMenuClick={(e) => handleMenuClick(e, record)}
                    buttons={[
                        {
                            key: "edit",
                            text: `${translation["Edit"] || TEXT["Edit"]}`,
                            icon: <EditOutlined />,
                        },
                        {
                            key: "delete",
                            text: `${translation["Delete"] || TEXT["Delete"]}`,
                            icon: <DeleteOutlined />,
                        },
                    ]}
                />
            ),
        },
    ];

    const getNews = () => {
        setLoading(true);
        const query = {
            page: currentPage,
            limit,
            pagination: 1,
            sort: JSON.stringify(sort),
            search: {},
        };

        if (search.title) {
            query.search["title"] = search.title[0];
        }
        if (search.description) {
            query.search["description"] = search.description[0];
        }

        // if (search.name) {
        //   query.search["name"] = search.name[0];
        // }

        if (query.search) {
            query.search = JSON.stringify(query.search);
        }

        if (date && date[0]) {
            let to = new Date(date[1]);
            to.setDate(to.getDate() + 1);
            query.between = JSON.stringify({
                createdAt: {
                    from: new Date(date[0]),
                    to: new Date(to),
                },
            });
        }

        goToPosts(query);

        REQUESTS.NEWS.GET(query, (data) => {
            setTotal(data.count);
            if (data.rows.length === 0 && currentPage !== 1) {
                setCurrentPage((current) => current - 1);
            } else {
                setCurrentPage(data.currentPage);
            }
            setLoading(false);
            setUserNewsList(data.rows);

            if (!data.rows == []) {
                setEmpty(false);
            }
        });
    };

    useEffect(() => {
        return () => {
            setEmpty(true);
        };
    }, []);

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter.field) {
            setSort([sorter.field, sorter.order === "ascend" ? "ASC" : "DESC"]);
        }
        setSearch(filters);

        if (Object.values(filters)[0]) {
            //   setTitleSearch(Object.values(filters)[0].join(""));
        } else {
            //   setTitleSearch(null);
        }

        setCurrentPage(pagination.current);
        setLimit(pagination.pageSize);
    };

    const onClickAdd = () => {
        setVisible(true);
    };

    const closeDrawer = () => {
        setVisible(false);
        setEditNews(null);
    };

    useEffect(() => {
        let timout = setTimeout(() => {
            getNews();
        }, 500);
        return () => {
            clearTimeout(timout);
        };
    }, [search, currentPage, limit, sort, date]);

    const followAddElement = {
        setCurrentPage: setCurrentPage,
        setSearch: setSearch,
        setSort: setSort,
        setCurrentPage: setCurrentPage,
        setLimit: setLimit,
        setTotal: setTotal,
        setDate: setDate,
    };

    return (
        <div className={classes["package_list_table"]}>
            <div className={classes["package_list_title"]}>
                <p className={classes["package_title-text"]}>
                    {translation["News"] || TEXT["News"]}
                </p>
                <Button
                    className={classes["package_add"]}
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={onClickAdd}
                />
            </div>

            <Table
                loading={loading}
                rowKey="id"
                columns={columns}
                dataSource={userNewsList}
                onChange={handleTableChange}
                pagination={{
                    position: ["bottomCenter"],
                    current: currentPage,
                    total: total,
                    pageSize: limit,
                    showSizeChanger: true,
                    // defaultPageSize: 1,
                }}
                scroll={{ x: "max-content" }}
            />
            
            <NewsTableDrawer
                visible={visible}
                onClose={closeDrawer}
                current={editNews}
                getData={getNews}
                translation={translation}
                followAddElement={followAddElement}
            />
        </div>
    );
}

export default NewsTable;
